<template>
  <div>
    <header-page></header-page>
    <div :class="isPlatform?'':'router-top'">
      <router-view />
    </div>
  </div>
</template>
<script>
import HeaderPage from '@/pages/common/views/components/headnav/HeadNav';

export default {
  name: 'Home',
  components: {
    HeaderPage,
  },
  computed: {
    isPlatform() {
      return this.$store.state.common.isPlatform
    }
  },
};
</script>
<style lang="less" scoped>
.router-top {
  padding-top:90px;
}
</style>
